const CSV_FOOD_INGEST_URL = process.env.API_URL + '/xugarhero/food_composition/csv';
const CSV_FOOD_GROUP_INGEST_URL = process.env.API_URL + '/xugarhero/food_composition/group/csv';
const OPTIONS = { headers: { 'Content-Type': 'multipart/form-data' } };

const uploadFoodCompositioCsv = (context, file) => {
  return new Promise((resolve, reject) => {
    context.$http.post(CSV_FOOD_INGEST_URL, formData(file), OPTIONS)
      .then(() => {
        resolve();
      }, error => {
        reject(error);
      });
  });
};

const downloadFoodComposition = (context, file) => {
  return new Promise((resolve, reject) => {
    context.$http.get(CSV_FOOD_INGEST_URL, formData(file), OPTIONS)
      .then(response => {
        resolve(response.bodyText);
      }, error => {
        reject(error);
      });
  });
};

const uploadFoodCompositioGroupCsv = (context, file) => {
  return new Promise((resolve, reject) => {
    context.$http.post(CSV_FOOD_GROUP_INGEST_URL, formData(file), OPTIONS)
      .then(() => {
        resolve();
      }, error => {
        reject(error);
      });
  });
};

const downloadFoodCompositionGroup = (context, file) => {
  return new Promise((resolve, reject) => {
    context.$http.get(CSV_FOOD_GROUP_INGEST_URL, formData(file), OPTIONS)
      .then(response => {
        resolve(response.bodyText);
      }, error => {
        reject(error);
      });
  });
};

const formData = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return formData;
};

export default {
  uploadFoodCompositioCsv,
  uploadFoodCompositioGroupCsv,
  downloadFoodComposition,
  downloadFoodCompositionGroup
};



// WEBPACK FOOTER //
// ./src/brand/health/api/csvFoodCompositionIngest/index.js